/**
 * All Permissions for Payter Internal Role
 */
export const PAYTER_INTERNAL_PERMISSIONS = [
  'terminalBulkActionSetAttribute',
  'contractShowHidden',
  'terminalDownloadLogs',
]
